import React from "react";

export default function AppleIcon({ className = "w-5 h-5" }) {
  return (
    <svg className={className} viewBox="0 0 24 24" aria-hidden="true">
      <path d="M17.05 12.04c-.03-2.7 2.2-3.99 2.3-4.06-1.25-1.83-3.2-2.08-3.9-2.11-1.66-.17-3.24.98-4.08.98-.84 0-2.13-.96-3.5-.93-1.8.03-3.46 1.05-4.39 2.67-1.87 3.24-.48 8.03 1.34 10.66.89 1.29 1.96 2.73 3.35 2.68 1.35-.06 1.86-.86 3.49-.86 1.63 0 2.1.86 3.53.83 1.46-.03 2.38-1.31 3.27-2.61 1.03-1.51 1.45-2.97 1.47-3.05-.03-.01-2.82-1.08-2.85-4.29zM14.52 4.3c.74-.9 1.24-2.14 1.1-3.39-1.06.04-2.35.71-3.12 1.6-.68.79-1.28 2.06-1.12 3.27 1.18.09 2.39-.6 3.14-1.48z" fill="#000" />
    </svg>
  );
}